export default "__VITE_ASSET__WMKrlQb5__"